// App.jsx
import React, { useEffect } from "react";
import {
  useNavigate,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./Home/Home";
import SupportingApp from "./SupportingApp/SupportingApp";
import Dashboards from "./Dashboards/Dashboards";
import KnowledgeCenter from "./KnowledgeCenter/KnowledgeCenter";
import Auth from "./Auth/Auth";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import "../assets/styles/globals.scss";
import "./App.scss";
import ProtectedRoute from "./Auth/ProtectedRoute";
import Header from "../components/Header/Header";
import { Outlet } from "react-router-dom";

const ProtectedLayout = () => {
  const { i18n } = useTranslation();

  return (
    <>
      <Header />
      <div
        className={classnames("app-container", {
          rightCtl: i18n.language === "ar",
        })}>
        <div className='content-section'>
          <Outlet />
        </div>
      </div>
    </>
  );
};

const App = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const root = document.querySelector(":root");
    if (i18n.language === "ar") {
      root.style.setProperty("--font-primary", "Bahij_TheSansArabic, sans-serif");
      root.style.setProperty("--font-primary-medium", "Bahij_TheSansArabic, sans-serif");
      root.style.setProperty("--font-arabic-regular", "Bahij_TheSansArabic, sans-serif");
      root.style.setProperty("--font-arabic-medium", "Bahij_TheSansArabic, sans-serif");
    } else {
      root.style.setProperty("--font-primary", "IBMPlexSansRegular, sans-serif");
      root.style.setProperty("--font-primary-medium", "IBMPlexSansRegular, sans-serif");
      root.style.setProperty("--font-arabic-regular", "Bahij_TheSansArabic, sans-serif");
      root.style.setProperty("--font-arabic-medium", "Bahij_TheSansArabic, sans-serif");
    }
  }, [i18n.language]);
  return (
    <Routes>
      {/* Public auth routes */}
      <Route path='/auth/*' element={<Auth />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<ProtectedLayout />}>
          <Route path='/' element={<Home />} />
          <Route path='/SupportingApp' element={<SupportingApp />} />
          <Route path='/dashboards' element={<Dashboards />} />
          <Route
            path='/SupportingApp/KnowledgeCenter'
            element={<KnowledgeCenter />}
          />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
